class TCSegmentUIModel {
  constructor({
    aircraftType = '',
    arrivalAirport = '',
    arrivalAirportRegion = '',
    arrivalAirportTimeZoneId = '',
    arrivalCountry = '',
    arrivalDateTime = '',
    arrivalTerminal = '',
    bookingClass = '',
    cabinClass = '',
    departureAirport = '',
    departureAirportRegion = '',
    departureAirportTimeZoneId = '',
    departureCountry = '',
    departureDateTime = '',
    departureTerminal = '',
    fareFamily = '',
    farebasis = '',
    flightDuration = null,
    hiddenStop = null,
    id = null,
    layoverDuration = null,
    marketingCarrier = '',
    marketingFlightCode = null,
    onUpgradeList = null,
    operatingCarrier = '',
    operatingFlightCode = null,
    remainingSegmentTimeToCheckin = null,
    segmentCode = '',
    segmentEntity = '',
    segmentRegion = '',
    segmentStatusCode = '',
    sequence = null,
    windowSegmentStatus = '',
  } = {}) {
    this.aircraftType = aircraftType;
    this.arrivalAirport = arrivalAirport;
    this.arrivalAirportRegion = arrivalAirportRegion;
    this.arrivalAirportTimeZoneId = arrivalAirportTimeZoneId;
    this.arrivalCountry = arrivalCountry;
    this.arrivalDateTime = arrivalDateTime;
    this.arrivalTerminal = arrivalTerminal;
    this.bookingClass = bookingClass;
    this.cabinClass = cabinClass;
    this.departureAirport = departureAirport;
    this.departureAirportRegion = departureAirportRegion;
    this.departureAirportTimeZoneId = departureAirportTimeZoneId;
    this.departureCountry = departureCountry;
    this.departureDateTime = departureDateTime;
    this.departureTerminal = departureTerminal;
    this.fareFamily = fareFamily;
    this.farebasis = farebasis;
    this.flightDuration = flightDuration;
    this.hiddenStop = hiddenStop;
    this.id = id;
    this.layoverDuration = layoverDuration;
    this.marketingCarrier = marketingCarrier;
    this.marketingFlightCode = marketingFlightCode;
    this.onUpgradeList = onUpgradeList;
    this.operatingCarrier = operatingCarrier;
    this.operatingFlightCode = operatingFlightCode;
    this.remainingSegmentTimeToCheckin = remainingSegmentTimeToCheckin;
    this.segmentCode = segmentCode;
    this.segmentEntity = segmentEntity;
    this.segmentRegion = segmentRegion;
    this.segmentStatusCode = segmentStatusCode;
    this.sequence = sequence;
    this.windowSegmentStatus = windowSegmentStatus;
  }
}

export default TCSegmentUIModel;